export const randomString = (f = undefined) => {
    const e = f || 32;
    const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    const a = t.length;
    let n = '';
    for (let i = 0; i < e; i++)
        n += t.charAt(Math.floor(Math.random() * a));
    return 'netease' + n;
};
